<template>
  <div class="page-wecom-seminar-middle"></div>
</template>
<script>
import { getEId, gotoActivity } from 'utils/wecom/seminar';
import { getRequest } from 'utils/string';
export default {
  name: 'Middle',
  computed: {
    code() {
      return getRequest()?.code || '';
    },
    userId() {
      return this.$route.params.userId;
    },
    type() {
      return this.$route.params.type;
    },
    isStatus() {
      return /^status$/i.test(this.type);
    },
    isEid() {
      return /^eid$/i.test(this.type);
    },
    errorCode() {
      if (this.isStatus) {
        return 'user-2';
      } else {
        return 'eid-2';
      }
    },
    failUrl() {
      return `/wecom/seminar/error/${this.errorCode}/${this.userId}`;
    }
  },
  created() {
    this.$loading.show();
    if (this.code) {
      if (this.isStatus) {
        this.statusProcess();
      } else {
        this.eidProcess();
      }
    } else {
      this.$location(this.failUrl);
    }
    this.$loading.hide();
  },
  methods: {
    eidProcess() {
      getEId(this.code)
        .then(res => {
          if (res?.data) {
            gotoActivity(this.userId);
          } else {
            this.$location(`/wecom/seminar/add/${this.userId}`);
          }
        })
        .catch(ex => {
          this.$location(this.failUrl);
        });
    },
    statusProcess() {
      getEId(this.code)
        .then(res => {
          if (res?.data) {
            this.$location(`/wecom/seminar/add/${this.userId}/service`);
          } else {
            this.$location(`/wecom/seminar/add/${this.userId}`);
          }
        })
        .catch(ex => {
          this.$location(this.failUrl);
        });
    }
  }
};
</script>
